import React, { useContext } from "react";

import constant from "lib/constant/constant";
import { Spinner } from "lib/components";

import { PrivateContext } from "lib/context";
import { storageHelper } from "lib/helpers";

import ManageAdvanceAccess from "app/advanceVendor/modules/operator/feature/manageAdvanceAccess/manageAdvanceAccess";

const { userKey } = constant;
const { operator } = userKey;

const AdvanceVendorAccess = () => {
  const { isLoading } = useContext(PrivateContext);
  const currentUserRole = storageHelper.get("userRole");

  const getComponent = (role) => {
    if (isLoading) {
      return <Spinner />;
    }
    if (role === operator) {
      return <ManageAdvanceAccess />;
    }
    return null;
  };

  const AdvanceProviderComponent = getComponent(currentUserRole);
  return AdvanceProviderComponent;
};

export default AdvanceVendorAccess;
